import { BoxProps } from "@mui/material";
// import { StyledEngineProviderProps } from "@mui/styled-engine/StyledEngineProvider";
import { Box, styled } from "components/common";

const drawerWidth = 250;
interface CustomBoxProps extends BoxProps {
  open?: boolean;
}

export const ProductsLeftWrapper = styled(Box)<CustomBoxProps>(
  ({ theme, open }) => ({})
);
